import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-hero',
  imports: [CtaButtonComponent],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroComponent {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly featureFlags = inject(FeatureFlagService);

  readonly profile = this.siteConfig.profile;

  readonly badges = computed(() => {
    this.featureFlags.flags();
    const hero = this.profile()?.hero;
    if (!hero) {
      return [];
    }
    return this.featureFlags.filterHeroBadges(hero.badges);
  });
}
